<template>
    <div data-cy="container_confirm_redeem_interface">
        <p v-html="msg" data-cy="text_confirm_redeem_interface_message"></p>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'InterfaceConfirmRedeem',
    mixins: [LocaleMixin],
    props: {
        campaign: Object
    },
    data: function () {
        return {
            msg: ''
        };
    },
    created: function () {
        this.msg = this.lbl.confirm_redeem.interface;
    }
}
</script>
